import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions_Wind from '~/Actions_Wind';
import * as getStatus from '~/skills/getStatus';
import * as getTime from '~/skills/getTime';
import {
  Select,
  MenuItem,
  TableRow,
  TableCell,
  TableHead,
  TableContainer,
  TableBody,
  Table,
} from '@material-ui/core';
import { ArrowBackIos, ArrowForwardIos, FirstPage, LastPage } from '@mui/icons-material';

import { S_Btn_Search, S_Btn_Add, S_Select, S_Title } from '~/components/SearchItem';
import { T_TitleCell, T_TableRow } from '~/components/TableItem';

class Page_ForeignBoat extends Component {
  state={
    ship_stage: '',

    per_page: 10,
    page: 1,

    sort: true,
    sort_field: 'upd_time',
  }

  componentDidMount () {
    const { ship_stage } = this.state;
    this.data = { ship_stage };
    this.props.getBoatStageList();
    this.refresh();
  }

  refresh=() => {
    const { windId } = this.props;
    const { page, per_page, sort, sort_field } = this.state;
    const { ship_stage } = this.data;
    this.props.getForeignBoatList({
      page,
      per_page,
      body: {
        ship_stage,
        sort: sort ? 'desc' : 'asc',
        sort_field,
      },
      windId,
    });
  }

  search=() => this.setState({ page: 1 }, () => this.refresh());

  _click_search=() => {
    const { ship_stage } = this.state;
    this.data = { ship_stage };
    this.search();
  }

  _delete=(id, act) => this.setState({ currentId: id, currentAct: act, view_checkDelete: true })
  _close_view_checkDelete=() => {
    // this.refresh();
    this.setState({ currentId: '', currentAct: '', view_checkDelete: false });
  }

  _add=() => this.setState({ view_addAndEdit: true, mode_addAndEdit: 'add' })
  _view=id => this.setState({ currentId: id, view_addAndEdit: true, mode_addAndEdit: 'view' })
  _edit=id => this.setState({ currentId: id, view_addAndEdit: true, mode_addAndEdit: 'edit' })
  _close_view_addAndEdit=() => {
    this.refresh();
    this.setState({ currentId: '', view_addAndEdit: false, mode_addAndEdit: '' });
  }

  toolBar=() => {
    const { BoatStageList = [] } = this.props;
    const { ship_stage } = this.state;
    return (
      <div style={{ marginTop: 24, display: 'flex' }}>
        <div>
          <S_Title text='階段' />
          <S_Select list={BoatStageList} value={ship_stage} onChange={t => this.setState({ ship_stage: t })} />
        </div>
        <div style={{ marginLeft: 16, display: 'flex', flexDirection: 'column-reverse' }}>
          <S_Btn_Search onClick={this._click_search} />
        </div>
      </div>
    );
  }

  toolBar2=() => (
    <div style={{ marginTop: 24, display: 'flex', alignItems: 'center' }}>
      <S_Btn_Add onClick={this._add} disabled={!this.props.canAdd} />
    </div>
  )

  renderTableTitle=() => {
    const { sort, sort_field } = this.state;
    const onChangeSort = t => {
      this.setState({ sort_field: t, sort: sort_field === t ? !sort : false }, () => this.search());
    };
    const ary = [
      { name: '階段', id: 'ship_stage' },
      { name: '申請船舶名稱', id: 'ship_name' },
      { name: '國籍', id: 'citizenship' },
      { name: '陸製船', id: 'is_made_china' },
      { name: '申請狀態' },
      { name: '申請船期起始' },
      { name: '申請船期結束' },
      { name: '抵台', id: 'is_taiwan' },
    ];
    return (
      <TableHead>
        <TableRow style={{ height: 48 }}>
          {ary.map((o, i) => (
            <T_TitleCell
              key={i}
              text={o.name}
              arrow={!!o.id}
              bol={sort_field === o.id ? sort : true}
              onClick={() => onChangeSort(o.id)}
            />
          ))}
        </TableRow>
      </TableHead>
    );
  }

  renderTableBody=() => {
    const { ForeignBoatList = {} } = this.props;
    const { list = [], page = 0, total = 0, per_page = 0 } = ForeignBoatList;
    const cellStyle = { fontSize: 14 };
    let start = 0;
    if (page > 0) {
      start = (page - 1) * per_page + 1;
      if (start > total)start = 0;
    }

    return (
      <TableBody>
        {list.map((o, i) => {
          const isApply =
          o.apply_sail_date &&
          (new Date() > getTime.returnDate(o.apply_sail_date)) &&
          ((o.sub3 || [])[0] || {}).start_date;

          return (
            <T_TableRow key={i} backgroundColor= {'white'}>
              <TableCell align='center' style={cellStyle}>{o.ship_stage}</TableCell>
              <TableCell align='center' style={cellStyle}>{o.ship_name}</TableCell>
              <TableCell align='center' style={cellStyle}>{o.citizenship}</TableCell>
              <TableCell align='center' style={cellStyle}>{o.is_made_china === '1' ? '是' : '否'}</TableCell>
              <TableCell align='center' style={cellStyle}>{getStatus.foreignBoat.fBApply(o)}</TableCell>
              <TableCell align='center' style={cellStyle}>
                {((isApply ? o.sub3 : o.sub2) || []).map((o2 = {}, i2) => <div key={i2} style={{ whiteSpace: 'nowrap' }}>{o2.start_date || '-'}</div>)}
              </TableCell>
              <TableCell align='center' style={cellStyle}>
                {((isApply ? o.sub3 : o.sub2) || []).map((o2 = {}, i2) => <div key={i2} style={{ whiteSpace: 'nowrap' }}>{o2.end_date || '-'}</div>)}
              </TableCell>
              <TableCell align='center' style={cellStyle}>{o.is_taiwan === '1' ? '是' : '否'}</TableCell>
            </T_TableRow>
          );
        })}
      </TableBody>
    );
  }

  renderTableBar=() => {
    const { ForeignBoatList = {} } = this.props;
    const { has_next = false, has_prev = false, page = 0, pages = 0, total = 0 } = ForeignBoatList;
    const { per_page, page: statePage } = this.state;
    const returnPages = () => {
      const array = [];
      for (let i = 1; i <= pages; i++) {
        array.push(i);
      }
      return array;
    };
    const returnPers = () => [10, 20, 30, 40];
    const canFirst = page > 1;
    const canLast = page < pages;
    return (
      <div style={{ height: 48, display: 'flex', alignItems: 'center', width: '100%', backgroundColor: 'white', borderBottomRightRadius: 8, borderBottomLeftRadius: 8, paddingTop: 6, paddingBottom: 6 }}>
        <div style={{ flex: 1 }} />
        <FirstPage style={{ height: 24, width: 24, color: canFirst ? 'black' : 'gray', cursor: canFirst ? 'pointer' : 'default' }} onClick={() => { if (canFirst) this.setState({ page: 1 }, () => this.refresh()); }} />
        <ArrowBackIos style={{ marginLeft: 3, marginRight: 5, height: 16, width: 16, color: has_prev ? 'black' : 'gray', cursor: has_prev ? 'pointer' : 'default' }} onClick={() => { if (has_prev) this.setState({ page: this.state.page - 1 }, () => this.refresh()); }} />
        <div style={{ fontSize: 14 }}>第</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px', marginRight: 8, marginLeft: 8 }}
          variant="outlined"
          value={statePage}
          onChange={e => this.setState({ page: e.target.value }, () => { this.refresh(); })}
        >
          {returnPages().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginRight: 8 }}>{`/${pages} 頁，每頁`}</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px' }}
          variant="outlined"
          value={per_page}
          onChange={e => this.setState({ per_page: e.target.value }, () => { this.search(); })}
        >
          {returnPers().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginLeft: 8 }}>{`筆，共${total}筆`}</div>
        <ArrowForwardIos style={{ marginLeft: 5, height: 16, width: 16, color: has_next ? 'black' : 'gray', cursor: has_next ? 'pointer' : 'default' }} onClick={() => { if (has_next) this.setState({ page: this.state.page + 1 }, () => this.refresh()); }} />
        <LastPage style={{ marginRight: 19, height: 24, width: 24, color: canLast ? 'black' : 'gray', cursor: canLast ? 'pointer' : 'default' }} onClick={() => { if (canLast) this.setState({ page: pages }, () => this.refresh()); }} />
        <div style={{ flex: 1 }} />
      </div>
    );
  }

  renderTable=() => {
    const { ForeignBoatList = {} } = this.props;
    const { list = [] } = ForeignBoatList;
    const haveData = list.length > 0;
    return (
      <TableContainer>
        <Table style={{ backgroundColor: 'white', borderTopRightRadius: 8 }}>
          {this.renderTableTitle()}
          {haveData && this.renderTableBody()}
        </Table>
      </TableContainer>
    );
  }

  render () {
    const { ForeignBoatList = {} } = this.props;
    const { list = [] } = ForeignBoatList;
    const haveData = list.length > 0;
    return (
      <div style={{ marginLeft: 52, marginRight: 52 }}>
        {this.toolBar()}
        <div style={{ display: 'flex', marginTop: 20 }}>
          <div style={ {
            backgroundColor: '#4CC2CA',
            height: 50,
            borderTopLeftRadius: 11,
            position: 'relative',
          }}
          >
            <div style={{ lineHeight: ' 50px', color: 'white', fontWeight: 700, fontSize: 20, marginLeft: 8, marginRight: 20 }}>外籍船舶</div>
            <div
              style={{
                backgroundColor: '#4CC2CA',
                height: 50,
                width: 40,
                clipPath: 'polygon(0% 100%, 0% 0%, 30% 0%, 100% 100%)',
                position: 'absolute',
                top: 0,
                left: ' calc(100% - 1px)',
              }}
            />
          </div>
        </div>
        <div style={{ borderRadius: 8, boxShadow: '0px 4px 13px rgba(24, 98, 121, 0.4)' }}>
          {this.renderTable()}
          {haveData && this.renderTableBar()}
        </div>
        {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  BoatStageList: state.data.BoatStageList,
  ForeignBoatList: state.data.ForeignBoatList,
});
const mapDispatchToProps = dispatch => ({
  getBoatStageList: () => Actions_Wind.getBoatStageList(dispatch),
  getForeignBoatList: body => Actions_Wind.getForeignBoatList(dispatch, body),
});

export default connect(mapStateToProps, mapDispatchToProps)(Page_ForeignBoat);
